import { TStyles } from "utils/Styles";

const Styles: TStyles = {
  default: {
    borderRadius: "8px",

    ".MuiCardActions-root": {
      justifyContent: "flex-end",
      pr: (theme) => theme.spacing(2),
      pb: (theme) => theme.spacing(2),
    },
  },
};

export default Styles;
